goog.provide("shadow.js.shim.module$$mui$material$Snackbar");
goog.provide("module$shadow_js_shim_module$$mui$material$Snackbar");
shadow.js.shim.module$$mui$material$Snackbar = shadow.js.nativeProvides["@mui/material/Snackbar"] = shadow$bridge("@mui/material/Snackbar");
module$shadow_js_shim_module$$mui$material$Snackbar.default = shadow.js.shim.module$$mui$material$Snackbar;
